import React from "react";

const Header = () => {
  return (
    <div className="d-flex justify-content-between m-2">
      <h4>B101</h4>
      <h4>Weather Analytics Dashboard</h4>
      <h4>29-Jan-2021</h4>
    </div>
  );
};

export default Header;
